import { render, staticRenderFns } from "./FechasBloqueadas.vue?vue&type=template&id=2ef211a9&"
import script from "./FechasBloqueadas.vue?vue&type=script&lang=js&"
export * from "./FechasBloqueadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports